import { useMemo } from 'react';
import { useInstantSearch } from 'react-instantsearch';
const useLoading = () => {
  const {
    status
  } = useInstantSearch();
  const isLoading = useMemo(() => status === 'loading' || status === 'stalled', [status]);
  return {
    isLoading,
    status
  };
};
export default useLoading;